import React, { useContext, useEffect } from "react"
import { Link } from "gatsby"
import CartContext from "../../context/CartProvider"
// import Cart from './Cart'

import "./Notify.css"
import CartWrapper from "./CartWrapper"
import CurrencyFormatter from "./CurrencyFormatter"
import { FaShippingFast } from "react-icons/fa"
import emblem from "../../images/FluoFoundationEmblem.png"
import echoGreetingsLogo from "../../images/Echo-Greetings-Logo.svg"

export default ({ products }) => {
  const value = useContext(CartContext)
  const notifications = value && value.notifications
  const hasNotifications = Array.isArray(notifications) && notifications.length
  const physical_items = value?.state?.cart?.lineItems?.physical_items || []

  // console.log({ physical_items, products })

  let totalCards = 0
  if (physical_items.length && products.length) {
    for (let i = 0; i < physical_items.length; i++) {
      const element = physical_items[i]
      const isCard = products.find(
        prod => prod.bigcommerce_id === element.product_id
      )
      if (isCard) totalCards += element.quantity
    }
  }

  return hasNotifications ? (
    <section className="Notify p-0">
      {notifications.map(note => (
        <Notification
          key={note.id}
          subtotal={value?.state?.cart?.cartAmount}
          {...note}
          totalCards={totalCards}
        />
      ))}
    </section>
  ) : null
}

const Notification = ({ id, text, type, subtotal, totalCards }) => {
  const value = useContext(CartContext)
  const removeNotification = value && value.removeNotification

  useEffect(() => {
    const timer = setTimeout(() => {
      removeNotification(id)
    }, 8000)
    return () => clearTimeout(timer)
    // eslint-disable-next-line
  }, [])

  function calculateShipping(subtotal) {
    if (subtotal < 150) {
      return 150 - subtotal
    }

    return 0
  }

  return (
    <article className="Notification Animate">
      <div className="Content">
        <div className="Message">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h3 className="mb-0">Your Bag</h3>
            <div className="Icon" onClick={() => removeNotification(id)}>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABs0lEQVRIie3WsWtUQRDH8U8CESxsDCLqJWihjSBa+EeIGvMPWNgpmksp/gEWgikUBUWxsNRKMdgmVVrttBFBG0GEnIWY5DiL2yOb4M3b9y6IRQYG9s3N731n5/btLrv2j2ysRu40LuE8jqKV4l/xGW/wCl92qrgjeIwN9Cq8ixepsJFsFj8LgNu9g5mm0Hn9GdSF5rNv14XOjgjN4cUzb2nW3qjth0vAz3YQOvAnVdBpw1fvQpZ3O4u/zOJ3h2g3bH5+f7V2UPU6zqS8ffiGNRxPsdMpZ5j+egR+Gwh7WMF4yp3HgzSewLsK7WIE/lgh7uFqyt2D/Wl8q0D3IQJ3Cl7wAwczzQn8KtB1ctC4rVayd6/h97bnboGuF/1Y0urLKXdvVujNAl3Y6qrFtZTBFnAljSfwvkIbLq4bgXAdp1LeSf0Wf8dkip0Vn2DXIvBUIL6TcsawnMUfZvr7QdHhBgJPg6qb+qMqKP2Dv+SzKvVVHCoBwzllN44q7+JiKXRgbaNfBObqQgc2o1nbV3GhKXRgB3BPfPLks3yu4D+tc71t2bzeHrP1evtJf4N4nZ537f+xPwy4fAaD89ELAAAAAElFTkSuQmCC"
                alt="Close"
              />
            </div>
          </div>
          <div className="alert alert-primary-fluo" role="alert">
            {text}
          </div>

          <div className="container">
            <CartWrapper />
          </div>

          <div className="Actions text-right mt-3">
            <Link
              to="/cart"
              className="btn btn-outline-fluo mr-3"
              onClick={() => removeNotification(id)}
            >
              View Bag
            </Link>
            <Link
              to="/checkout"
              className="btn btn-fluo"
              onClick={() => removeNotification(id)}
            >
              Proceed to Checkout
            </Link>
          </div>

          <div
            style={{ maxWidth: 600, margin: "3rem auto 3rem auto" }}
            className="w-100"
          >
            <div className="row w-100 border-bottom">
              <div className="col-md-6 border-right">
                <center>
                  <img
                    className="img-fluid"
                    src={emblem}
                    alt="emblem"
                    style={{ width: 200 }}
                  />
                </center>
                <p className="small mt-3">
                  Bravo 20% of your purchase today is going towards the mental
                  wellness of our youth.
                </p>
              </div>
              <div className="col-md-6">
                <div className="text-right d-flex flex-column justify-content-end h-100">
                  <h5 className="text-uppercase font-weight-bold">
                    <FaShippingFast /> <span>free shipping</span>
                  </h5>
                  <p className="small">
                    <span>
                      {`You're `}

                      <CurrencyFormatter
                        currency={"USD"}
                        amount={calculateShipping(subtotal)}
                      />
                      {` away from "Free Shipping" on orders shipped within the U.S`}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between mt-3">
              {totalCards >= 12 ? (
                <h4 className="font-weight-bold txt-fluo mb-0 text-center mt-3 mr-3">
                  You are now receiving $1.00 OFF on ALL your Echo Greetings
                  Cards!
                </h4>
              ) : (
                <div className="d-flex">
                  <ul className="txt-fluo mr-3">
                    <li className="small">3 Cards for $13.50</li>
                    <li className="small">6 Cards for $25</li>
                    <li className="small">12 Cards for $48</li>
                  </ul>

                  <ul className="list-unstyled">
                    <li className="small">
                      <em className="text-dark">{`(Add ${
                        totalCards <= 3 ? 3 - totalCards : 0
                      } more to save $1.50)`}</em>
                    </li>
                    <li className="small">
                      <em className="text-dark">{`(Add ${
                        totalCards <= 6 ? 6 - totalCards : 0
                      } more to save $5)`}</em>
                    </li>
                    <li className="small">
                      <em className="text-dark">{`(Add ${totalCards < 12 &&
                        12 - totalCards} more to save $12)`}</em>
                    </li>
                  </ul>
                </div>
              )}

              <img
                className="img-fluid"
                src={echoGreetingsLogo}
                alt="emblem"
                style={{ width: 150 }}
              />
            </div>
          </div>
        </div>
      </div>
    </article>
  )
}
